const _lifeInsCalc = function() {
    let chosenCoverQuestions = [];
    let formPageOneValid = false;
    let formIsValid = false;
    let inputsValid = false;
    let childrenQuestionRadioSelected = false;
    let childrenQuestionSelectsValid = true;
    let isChildrenQuestionPicked = false;
    let numberInputs;
    const form = document.getElementById('life-insurance-calculator');
    const formPageOne = document.getElementById('form-page-one');
    const formPageTwo = document.getElementById('form-page-two');
    const formPageThree = document.getElementById('form-page-three');
    const formPageOneBtn = document.getElementById('form-page-one--action');
    const formPageTwoBackBtn = document.getElementById('back-button');
    const startAgainBtn = document.querySelector('#form-page-three button');
    const progressBar = document.querySelector('.life-insurance-calculator-container .background-bar');
    const childrenRadios = Array.prototype.slice.call(document.querySelectorAll('.life-insurance-calculator-container input[name="children-question"]'), 0);
    const stepNumber = document.getElementById('progress-indicator__step-number');
    const formPageOneCheckboxes = Array.prototype.slice.call(document.querySelectorAll('.life-insurance-calculator-container #form-page-one input[type="checkbox"]'), 0);
    
    /* Start Event Listeners */
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        checkForEmptyTextBoxes();
        isChildrenQuestionPicked && checkchildrenQuestionRadioSelected();
        formIsValid = inputsValid && childrenQuestionRadioSelected && childrenQuestionSelectsValid;

        if (isChildrenQuestionPicked) {
            formIsValid = inputsValid && childrenQuestionRadioSelected && childrenQuestionSelectsValid;
        } else {
            formIsValid = inputsValid;
        }

        if (formIsValid) {
            document.getElementById('result').textContent = "\xA3".concat(runCalculation());
            togglePage(formPageTwo, formPageThree, "step-three", "3");
        } else {
            // Number field validation
            if (!inputsValid) {
                numberInputs && numberInputs.forEach(function(input) {
                    if (input.value !== "") return;

                    const labelId = input.getAttribute('aria-labelledby');
                    const label = document.getElementById(labelId);
                    let errorLocation = label.nextElementSibling;

                    if (errorLocation.className === "tooltip" || errorLocation.className === "expanded-help") errorLocation = errorLocation.nextElementSibling;

                    const errorExists = errorLocation.className === "field-validation-error" ? true : false;
                    if (errorExists) return; // Create and add error message to DOM

                    input.parentElement.classList.add('error');

                    let errorMessageText;
                    switch (labelId) {
                        case "mortgage-label":
                            errorMessageText = "Enter how much is left to pay on your mortgage";
                            break;

                        case "debt-label":
                            errorMessageText = "Enter how much debt you have left to pay";
                            break;

                        case "earn-label":
                            errorMessageText = "Enter how much you earn per month after tax";
                            break;

                        case "funeral-label":
                            errorMessageText = "Enter how much you want to put towards your funeral";
                            break;
                    }

                    const errorDiv = createErrorState(errorMessageText);
                    errorLocation.insertAdjacentElement('beforebegin', errorDiv);
                });
            }

            // Children radio button validation
            if (isChildrenQuestionPicked && !childrenQuestionRadioSelected) {
                const errorLocation = document.querySelector('#children-question .tooltip').nextElementSibling;
                const errorExists = errorLocation.className === "field-validation-error" ? true : false;
                if (errorExists) return; // Create and add error message to DOM

                const errorDiv = createErrorState('Select how many children you have');
                errorLocation.insertAdjacentElement('beforebegin', errorDiv);
            }
        }
    });

    formPageOneCheckboxes.forEach(function(checkbox) {
        return checkbox.addEventListener('change', function(e) {
            return handlePageOneCheckboxes(e);
        });
    });

    formPageOneBtn.addEventListener('click', function(e) {
        e.preventDefault();

        formPageOneCheckboxes.forEach(function(checkbox) {
            if (checkbox.checked) formPageOneValid = true;
            if (checkbox.getAttribute('id') === "checkbox-children" && checkbox.checked) isChildrenQuestionPicked = true;
        });

        if (formPageOneValid) {
            handleShowQuestions();
            togglePage(formPageOne, formPageTwo, "step-two", "2");
            numberInputs = Array.prototype.slice.call(document.querySelectorAll('.life-insurance-calculator-container input[type="number"]:not([aria-hidden="true"])'), 0);
            numberInputs && numberInputs.forEach(function(input) {
                return input.addEventListener('keyup', function(e) {
                    return removeErrorMessage(e, input);
                });
            });
        } else {
            const errorMessage = document.querySelector('#form-page-one .field-validation-error');

            if (errorMessage === null) {
                const errorDiv = createErrorState('Select what you want your life insurance to cover');
                const errorLocation = document.querySelector('.life-insurance-calculator-container .tooltip');
                errorLocation.insertAdjacentElement('afterend', errorDiv);
            }
        }
    });
    formPageTwoBackBtn.addEventListener('click', function(e) {
        e.preventDefault();
        handleShowQuestions();
        reset();
        togglePage(formPageTwo, formPageOne, "step-one", "1");
    });
    startAgainBtn.addEventListener('click', function(e) {
        e.preventDefault();
        handleShowQuestions();
        reset();
        togglePage(formPageThree, formPageOne, "step-one", "1");
    });
    childrenRadios.forEach(function(radio) {
        return radio.addEventListener('change', function(e) {
            return showChildrenExtaInfo(e);
        });
    });
    document.addEventListener('change', function(e) {
        const _this = e.target;

        if (_this && _this.tagName === 'SELECT') {
            const parent = _this.parentElement;
            const errorMessage = parent.querySelector('.field-validation-error');

            if (errorMessage !== null) {
                parent.removeChild(errorMessage);
            }
        }
    });
    /* End Event Listeners */

    const runCalculation = () => {
        const mortgageField = document.getElementById('input-shell--number__mortgage');
        const debtField = document.getElementById('input-shell--number__debt');
        const earnField = document.getElementById('input-shell--number__earn');
        const funeralField = document.getElementById('input-shell--number__funeral');
        const howManyChildren = document.querySelector('.life-insurance-calculator-container input[type="radio"]:checked');
        const selects = Array.prototype.slice.call(document.querySelectorAll('.life-insurance-calculator-container select'), 0);
        const mortgageValue = mortgageField === null ? 0 : mortgageField.value * 1;
        const debtValue = debtField === null ? 0 : debtField.value * 1;
        const earnValue = earnField === null ? 0 : earnField.value * 12 * 4;
        const funeralValue = funeralField === null ? 0 : funeralField.value * 1;
        const childrenUniValue = howManyChildren === null ? 0 : howManyChildren.value * 51000;
        let childrenValueTotal = 0;
        selects.forEach(function(select) {
            const childrenValue = select.value * 6000;
            childrenValueTotal += childrenValue;
        });
        const total = (mortgageValue + debtValue + earnValue + funeralValue + childrenUniValue + childrenValueTotal).toLocaleString();
        return total;
    };

    const checkForEmptyTextBoxes = function checkForEmptyTextBoxes(e) {
        let shouldSkip = false;

        if (!numberInputs || !numberInputs.length) {
            // No number inputs are needed to be filled by the user
            inputsValid = true;
            return;
        }

        numberInputs && numberInputs.forEach(function(input) {
            if (shouldSkip) return;

            if (input.value === "" || isNaN(input.value)) {
                inputsValid = false;
                shouldSkip = true;
            } else {
                inputsValid = true;
            }
        });
    };

    const checkchildrenQuestionRadioSelected = () => {
        const checkedRadio = document.querySelector('.life-insurance-calculator-container input[type="radio"]:checked');
        if (checkedRadio !== null) childrenQuestionRadioSelected = true; // A radio button has been selected
        // Check all selects have a value

        Array.prototype.slice.call(document.querySelectorAll('.life-insurance-calculator-container select'), 0).forEach(function(select) {
            if (select.value === "Select an option") {
                // Check that there is no error already
                const parent = select.parentElement;
                const isError = parent.querySelector('.field-validation-error') !== null;

                if (isError) {
                    childrenQuestionSelectsValid = false;
                    return;
                } // Create error message and add to dom


                let childNum;

                switch (select.id.toString().slice(-1)) {
                    case "1":
                        childNum = "first";
                        break;

                    case "2":
                        childNum = "second";
                        break;

                    case "3":
                        childNum = "third";
                        break;

                    case "4":
                        childNum = "fourth";
                        break;

                    case "5":
                        childNum = "fifth";
                        break;
                }

                const errorMessageText = "Select how old your ".concat(childNum, " child is from the list");
                const error = createErrorState(errorMessageText);
                select.insertAdjacentElement('beforebegin', error);
                childrenQuestionSelectsValid = false;
            } else {
                childrenQuestionSelectsValid = true;
            }
        });
    };

    const handlePageOneCheckboxes = e => {
        // Remove error message on click
        const errorMessage = document.querySelector('#form-page-one .field-validation-error');
        if (errorMessage !== null) errorMessage.parentElement.removeChild(errorMessage);
        const checkbox = e.target;
        const checked = checkbox.checked;
        const chosenCheckbox = checkbox.value;
        const alreadyChosen = chosenCoverQuestions.indexOf(chosenCheckbox) >= 0;

        if (checked && !alreadyChosen) {
            chosenCoverQuestions.push(chosenCheckbox);
        } else if (!checked && alreadyChosen) {
            const index = chosenCoverQuestions.indexOf(chosenCheckbox);
            chosenCoverQuestions.splice(index, 1);
        }
    };

    const showChildrenExtaInfo = e => {
        // Remove any errors
        const errorMessage = document.querySelector('#children-question .field-validation-error');

        if (errorMessage !== null) {
            const parent = errorMessage.parentElement;
            parent.removeChild(errorMessage);
        }

        const childrenCount = e.target.value;
        const childrenQuestionWrapper = document.querySelector('.life-insurance-calculator-container .children-question__extra-info');
        let i = 1;
        let labelText;
        childrenQuestionWrapper.innerHTML = "";

        while (i <= childrenCount) {
            switch (i) {
                case 2:
                    labelText = "second";
                    break;

                case 3:
                    labelText = "third";
                    break;

                case 4:
                    labelText = "fourth";
                    break;

                case 5:
                    labelText = "fifth";
                    break;

                default:
                    labelText = "first";
                    break;
            }

            childrenQuestionWrapper.insertAdjacentHTML('beforeend', generateSelectHtml(labelText, i));
            i++;
        }
    };

    const generateSelectHtml = (labelText, count) => {
        return "<div class=\"input-shell input-shell--select\">\n                    <label for=\"children-question-age-".concat(count, "\">How old is your ").concat(labelText, " child?</label>\n                    <select class=\"input-shell--select__field\" id=\"children-question-age-").concat(count, "\">\n                        <option>Select an option</option>\n                        <option value=\"1\">Less than 1</option>\n                        <option value=\"2\">1</option>\n                        <option value=\"3\">2</option>\n                        <option value=\"4\">3</option>\n                        <option value=\"5\">4</option>\n                        <option value=\"6\">5</option>\n                        <option value=\"7\">6</option>\n                        <option value=\"8\">7</option>\n                        <option value=\"9\">8</option>\n                        <option value=\"10\">9</option>\n                        <option value=\"11\">10</option>\n                        <option value=\"12\">11</option>\n                        <option value=\"13\">12</option>\n                        <option value=\"14\">13</option>\n                        <option value=\"15\">14</option>\n                        <option value=\"16\">15</option>\n                        <option value=\"17\">16</option>\n                        <option value=\"18\">17</option>\n                    </select>\n                </div>");
    };

    const createErrorState = (text) => {
        const fieldValidationDiv = document.createElement('div');
        fieldValidationDiv.setAttribute('class', 'field-validation-error');
        const errorText = document.createElement('span');
        errorText.textContent = text;
        fieldValidationDiv.appendChild(errorText);
        return fieldValidationDiv;
    };

    const removeErrorMessage = (e, input) => {
        const isNumber = /^[0-9]$/i.test(e.key);

        if (isNumber) {
            const labelId = input.getAttribute('aria-labelledby');
            const parent = document.getElementById(labelId).parentElement;
            const errorMessage = parent.querySelector('.field-validation-error');
            if (errorMessage === null) return;
            input.parentElement.classList.remove('error');
            errorMessage.parentElement.removeChild(errorMessage);
        }
    }; // Completely resets the app to the default starting state


    const reset = () => {
        chosenCoverQuestions = [];
        clearAllErrors();
        formPageOneCheckboxes.length > 0 && formPageOneCheckboxes.forEach(function(checkbox) {
            return checkbox.checked = false;
        });
        childrenRadios.length > 0 && childrenRadios.forEach(function(radio) {
            return radio.checked = false;
        });
        numberInputs && numberInputs.length > 0 && numberInputs.forEach(function(input) {
            return input.value = "";
        });
        document.querySelector('.life-insurance-calculator-container .children-question__extra-info').innerHTML = "";
        formPageOneValid = false;
        inputsValid = false;
        isChildrenQuestionPicked = false;
        childrenQuestionRadioSelected = false;
        childrenQuestionSelectsValid = true;
        formIsValid = false;
    };

    const clearAllErrors = () => {
        Array.prototype.slice.call(document.querySelectorAll('.life-insurance-calculator-container .field-validation-error'), 0).forEach(function(error) {
            error.parentElement.removeChild(error);
        });
        Array.prototype.slice.call(document.querySelectorAll('.life-insurance-calculator-container .error'), 0).forEach(function(errorClass) {
            return errorClass.classList.remove('error');
        });
    };

    const toggleClass = (el, className) => {
        el.classList.toggle(className);
    };

    const togglePage = (from, to, step, stepNum) => {
        stepNumber.innerHTML = stepNum;
        progressBar.className = "background-bar ".concat(step);
        [from, to].forEach(function(elem) {
            return toggleClass(elem, "visuallyhidden");
        });
    };

    const handleShowQuestions = () => {
        chosenCoverQuestions.forEach(function(question) {
            const id = document.querySelector(".life-insurance-calculator-container #".concat(question, "-question"));
            const input = document.querySelector(".life-insurance-calculator-container #".concat(question, "-question input"));
            id.getAttribute('aria-hidden') === "true" ? id.setAttribute('aria-hidden', "false") : id.setAttribute('aria-hidden', "true");
            input.getAttribute('aria-hidden') === "true" ? input.setAttribute('aria-hidden', "false") : input.setAttribute('aria-hidden', "true");
            toggleClass(id, "visuallyhidden");
        });
    };
}();